import { contract } from './constant';

const { GET_CONTRACT_COUNT_REQUEST } = contract;

export const getContractCountAction = () => {
  return {
    type: GET_CONTRACT_COUNT_REQUEST,
  };
};
